<div class="dd-vehicles-page">
  <dd-app-menu></dd-app-menu>
  <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start center" class="dd-card-background-gray">
    <div fxLayout="column">
      <div class="dd-customer-name" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="center center">
        <dd-page-title title="Selected Vehicles"></dd-page-title>
      </div>
      <div class="dd-card-container" fxLayout="row" fxLayoutAlign="center center">
        <div fxLayout="row" fxLayoutAlign="start start" class="dd-max-width">
          <div fxLayout="row" fxLayoutAlign="start start">
            <div fxLayout="row wrap" fxLayoutAlign="start start">
              <div  *ngFor="let vehicle of responseData?.vehicles; let i=index">
                <dd-vehicle-card [responseData]="responseData" [vehicle]="vehicle" [cardNumber]="(i + 1) + '/' + responseData?.vehicles?.length" (click)="omTag.fireOmnitureTag('vh_aa-link_vehicle_module', {url:vehicle.media[0].href, href: vehicle.media[0].href, text: vehicle.marketingSeries , trigger: 'aa-link', listIndex: (i + 1), part: null, vehicleDetails: vehicle}, this.sharedData)"></dd-vehicle-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="column" class="dd-content-margin">
    <div fxLayout="column" fxLayoutAlign="center center" class="dd-dealer-info-title">
      DEALER INFORMATION
    </div>
    <div class="dealer-info">
      <div class="dealer-info-direction-wrapper" [ngClass]="isMapLoaded ? 'google-map-loaded' : ''">
      <div class="dealer-info-direction">
        <div fxLayout="row">
          <dd-dealer-details [dealerDetails]="sharedData?.dealerDetails" [layoutAlign]="'start start'"></dd-dealer-details>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" class="dd-contact-us-container">
          <dd-phone-number [phoneNumber]="sharedData?.dealerDetails?.phone" (click)="omTag.fireOmnitureTag('vh_km-dealer-contact-call', {url:'', href: '', text:sharedData?.dealerDetails?.phone, trigger:'km-link', dealerCd:responseData.dealerCd}, sharedData)"></dd-phone-number>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" class="dd-get-direction-container">
          <dd-get-directions [dealerDetails]="sharedData?.dealerDetails" (click)="omTag.fireOmnitureTag('vh_aa-link_dealer_info_module', {url:$event.srcElement.href, href: $event.srcElement.href, text:$event.srcElement.innerText, trigger:'aa-link', dealerCd:responseData.dealerCd}, sharedData)"></dd-get-directions>
        </div>
        <div fxLayout="column" class="dd-hours-text">
          Sales Hours
        </div>
        <div fxLayout="column" class="dd-weekly-hours-contianer">
          <mat-accordion>
            <mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="dd-weekly-day">
                  Today
                </mat-panel-title>
                <mat-panel-description class="dd-weekly-hours">
                  <div>{{sharedData?.dealerDetails?.todayHoursOfOperation?.availabilityStartTimeMeasure |
                    minutesToTime}} - {{sharedData?.dealerDetails?.todayHoursOfOperation?.availabilityEndTimeMeasure |
                    minutesToTime}}</div>
                  <mat-icon class="dd-expansion-icon" *ngIf="panelOpenState == false">arrow_drop_down</mat-icon>
                  <mat-icon class="dd-expansion-icon" *ngIf="panelOpenState == true">arrow_drop_up</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="column" class="mat-expansion-panel-body">
                <div fxLayout="row" class="dd-exp-body-margin" *ngFor="let ho of sharedData?.dealerDetails?.hoursOfOperation">
                  <div class="dd-weekly-day">{{ ho.dayOfWeekCode }}</div>
                  <div class="dd-weekly-hours" *ngIf="ho.availabilityStartTimeMeasure !== null">{{ho.availabilityStartTimeMeasure
                    | minutesToTime}} - {{ho.availabilityEndTimeMeasure | minutesToTime}}</div>
                  <div class="dd-weekly-hours" *ngIf="ho.availabilityStartTimeMeasure === null">-</div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center" class="dd-btn-contact-dealer-container">
          <!-- <button class="dd-btn-contact-dealer">CONTACT DEALER</button> -->
          &nbsp;
        </div>
      </div>
      <div fxLayout="column" fxFlex="100%" fxFlex.sm="45%" fxFlex.gt-sm="60%" fxFlexOrder="1" fxFlexOrder.gt-xs="2"
        class="dd-google-map-container">
        <div class="health-status--map-container" *ngIf="isMapLoadedError | async; else correctMap">
          <div class="health-status--map-error">
            <span class="health-status--map-error-text">Map is not available</span>
          </div>
        </div>
        <ng-template #correctMap>
          <div class="health-status--map-container" *ngIf="isMapLoaded | async; else loadingMap">
            <img class="health-status--map" [src]="telemetryLocationImage"/>
          </div>
          <ng-template #loadingMap>
            <div class="health-status--map-loading">
              <img src="../../../../assets/icons/loader.svg" height="100px" alt="Loading...">
            </div>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </div>
</div>
